<template>
  <v-sheet :style="styles" class="vx-scroll">
    <slot />
  </v-sheet>
</template>

<script>
export default {
  props: {
    offset: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    styles() {
      return {
        height: `calc(100vh - ${
          this.offset +
          this.$vuetify.application.top +
          this.$vuetify.application.bottom +
          this.$vuetify.application.insetFooter
        }px)`,
        overflowY: "scroll",
      };
    },
  },
};
</script>
